module.exports = __webpack_public_path__ + "static/media/logo-artchivo.43135049.png";